import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from 'src/app/core/guards/auth-guard';
import {MonitoringListComponent} from './list/list.component';
import {RoleEnum} from "../../shared/enums/role.enum";

const routes: Routes = [
  {
    path: 'list',
    canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.STATUS_EQUIPAMENTOS])],
    component: MonitoringListComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StatusMonitoringRoutingModule { }
